<template>
  <v-tooltip bottom>
    <template v-slot:activator="{ on, attrs }">
      <span v-bind="attrs" v-on="on">
        <v-btn
    :data-testid="dataTestid" icon :color="color" v-bind="$attrs" v-on="$listeners">
          <v-icon>{{ icon }}</v-icon>
        </v-btn>
      </span>
    </template>
    {{ tooltip }}
  </v-tooltip>
</template>

<script>
export default {
  props: {
    "data-testid": {
      type: String,
      required: false,
    },
    icon: {
      type: String,
      required: true,
    },
    color: {
      type: String,
      required: false,
    },
    tooltip: {
      type: String,
      required: true,
    },
  },
};
</script>
